import { useEffect, useState } from 'react'

const PWAInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null)
  const [showInstallButton, setShowInstallButton] = useState(false)

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault()
      setDeferredPrompt(e)
      setShowInstallButton(true)
    }

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt)

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
    }
  }, [])

  const handleInstallClick = async () => {
    if (!deferredPrompt) return

    deferredPrompt.prompt()

    const { outcome } = await deferredPrompt.userChoice
    if (outcome === 'accepted') {
      console.log('✅ Installation acceptée par l\'utilisateur')
    } else {
      console.log('❌ Installation refusée')
    }

    setShowInstallButton(false)
    setDeferredPrompt(null)
  }

  if (!showInstallButton) return null

  return (
    <button
      onClick={handleInstallClick}
      style={{
        position: 'fixed',
        bottom: 96,
        right: 28,
        padding: '10px 16px',
        borderRadius: '12px',
        backgroundColor: '#764B26',
        color: 'white',
        fontWeight: 'bold',
        boxShadow: '0px 4px 12px rgba(0,0,0,0.2)',
        border: 'none',
        cursor: 'pointer',
        zIndex: 998,
        transition: 'all 0.3s ease',
        fontSize: '13px',
      }}
    >
      📲 Installer {import.meta.env.VITE_APP_NAME}
    </button>
  )
}

export default PWAInstallPrompt
